import { render, staticRenderFns } from "./table-container.vue?vue&type=template&id=bdb68d4c&scoped=true"
import script from "./table-container.vue?vue&type=script&lang=js"
export * from "./table-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb68d4c",
  null
  
)

export default component.exports